import React, {useState, useEffect} from "react";

import {Grid, Typography} from "@mui/material";
import {connect} from "react-redux";
import {
    getServiceOptions,
    getSharedMunicipalities,
    setFunction,
} from "../../../function.actions";
import {CompPartitionHeader} from "../../../../../components/PartitionHeader";
import {handleDateTimeChange} from "../../../components/functionFormComponentUtils";
import { IconButton, Tooltip } from '@mui/material';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import moment from "moment";
import { isFunction } from "../../../../../utils";
import {
    hasPermission,
    PERMISSION_CREATE_FUNCTION_ANY_MUNICIPALITY,
    PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER
} from "../../../../../permissions";
import {useTranslation} from "react-i18next";
import {CompCheckbox} from "../../../../../components/Checkbox";
import { CompDropdownNew } from "../../../../../components/newComponents/DropdownNew";
import {getFunctionTypeOptions} from "../../../../root/root.utils";
import {CompMultiselectDropdown2 as MultiselectDropdown2} from "../../../../../components/MultiselectDropdown2";
import {formatISODateStr} from "../../../../../utils";
import {EventHoursTimePicker} from "../../../components/EventHoursTimePicker";
import { CompSearchInputNew } from "../../../../../components/newComponents/SearchInputNew";
import { CompTextFieldNew } from "../../../../../components/newComponents/TextField";
import { CompDatePickerNew } from "../../../../../components/newComponents/DatePickerNew";
import { CompTimePickerNew } from "../../../../../components/newComponents/TimePickerNew";
import { SearchMultiselectDropdown } from "../../../../../components/newComponents/SearchMultiselectDropdown";

const FunctionInformationComponent = (props) => {
    const {
        fieldErrors = {},
        /* handleChange, */
        editorActivated,
        onChange,
        sectionHasError,
        authenticatedUser,
        setFunction,
        selectedFunction,
        selectedMunicipalityUsers,
        contentIdentifiers,
        services,
        methods,
        municipalities,
        action,
        municipalitySelect,
        forceOrganizer
    } = props;

    const {t} = useTranslation('translation');
    const disableAll = !editorActivated || action === "share";
    const shared = action === "share";
    const [intendedContentIdentifierList, setIntendedContentIdentifierList] = useState([]);

    const permissionToCreateFunctionBehalfOfAnother = hasPermission(PERMISSION_CREATE_FUNCTION_BEHALF_OF_ANOTHER, authenticatedUser);
    //const municipalitySelect = hasPermission(PERMISSION_CREATE_FUNCTION_ANY_MUNICIPALITY, authenticatedUser);

    useEffect(() => {
        setIntendedContentIdentifierList(filteredContentIdentifier());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const selectedContentIdentifiers = [];
    if ('contentIdentifiers' in selectedFunction) {
        selectedFunction.contentIdentifiers.forEach(function (identifier) {
            selectedContentIdentifiers.push(identifier.id ? identifier.id : identifier);
        });
    }

    const selectedMethods = [];
    if ('methods' in selectedFunction) {
        selectedFunction.methods.forEach(function (method) {
            selectedMethods.push(method.id);
        });
    }

    const filteredContentIdentifier = () =>  {
        var filtered = contentIdentifiers.filter(
            (item) => {
                var text = t('report.current_language') === "FINNISH" ? item.titleFi : item.titleSv;
                return text !== null && text.length > 0;
            });

        if ('contentIdentifiers' in selectedFunction) {
            selectedFunction.contentIdentifiers.forEach(sci => {
                var found = false;
                for (var ci of contentIdentifiers) {
                    if (ci.id === sci.id) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    filtered.push(sci);
                }
            })
        }

        const spacer = '\xA0'.repeat(6);
        filtered.forEach(row => {
                row.currentTitle = `${row.parentId === null ? '' : spacer}${t('report.current_language') === "FINNISH" ? row.titleFi : row.titleSv}${row.parentId === null ? ' - ' + t('common.nationwide_short') : ''}`
            }
        )
        filtered.sort((a,b) => a.currentTitle.localeCompare(b.currentTitle));


        const tbr = [];
        const parentsToChildrenMap = new Map();
        filtered.forEach(item => {
            if (item.parentId == null) {
                parentsToChildrenMap.set(item.id, []);
            }
        });
        filtered.forEach(item => {
            if (item.parentId !== null && parentsToChildrenMap.get(item.parentId)) {
                parentsToChildrenMap.get(item.parentId).push(item);
            }
        });
        filtered.forEach(item => {
            if (item.parentId == null && item.state === 'PUBLISHED') {
                tbr.push(item);
                tbr.push(...parentsToChildrenMap.get(item.id));
            }

            if (item.state !== 'PUBLISHED' || (item.parentId !== null && !parentsToChildrenMap.get(item.parentId))) {
                item.currentTitle = "(" +t('common.archived') + ") " + item.currentTitle;
                tbr.push(item);
            }
        });
        return tbr;
    }
    //NOTE, MUI requires the use of "event" in checkbox components. Removing it will cause the checkbox to fail to work.
    //Please stick on using event.target.checked on checkboxes atleast
    const handleSelectChange = (event) => {
        setFunction({
            ...selectedFunction,
            shared: event.target.checked
        })
    }

    const handleChange = (event, changedData) => {
        let data = {
            ...selectedFunction,
            [event.target.name]: event.target.value
        }
        if (changedData) {
            data = {
                ...selectedFunction,
                ...changedData
            }
        }
        setFunction(data);
        if (isFunction(onChange)) {
            onChange(event)
        }
    };

    const handleStartDateChangeForCopy = (e) => {
        const newStartDate = e.target.value; 
        const mockedFunction = { ...selectedFunction };
        
        let timePart = "23:59:59";
        if (mockedFunction.endDatetime) {
            const rawEnd = mockedFunction.endDatetime;
            let existingTime = "";
            
            if (typeof rawEnd === 'string' && rawEnd.includes('T')) {
                existingTime = rawEnd.split('T')[1];
            } else if (typeof rawEnd === 'object') {
                if (typeof rawEnd.format === 'function') {
                    existingTime = rawEnd.format('HH:mm:ss');
                } else if (rawEnd instanceof Date && !isNaN(rawEnd)) {
                    existingTime = rawEnd.toTimeString().split(' ')[0];
                }
            }

            if (existingTime && !existingTime.startsWith("00:00")) {
                timePart = existingTime;
            }
        }
        
        const updatedIsoString = `${newStartDate}T${timePart}`;
        const newEndDatetimeObj = typeof moment !== 'undefined' 
            ? moment.utc(updatedIsoString) 
            : updatedIsoString;
        mockedFunction.endDate = newStartDate;
        mockedFunction.endDatetime = newEndDatetimeObj;

        const syncHandleChange = (event, changedData) => {
            let newData = {
                [event.target.name]: newStartDate,
                ...(changedData || {}) 
            };
            newData.endDate = newStartDate;
            newData.endTime = timePart;
            newData.endDatetime = newEndDatetimeObj;
            
            handleChange(event, newData);
        };
        handleDateTimeChange(e, 'startDate', mockedFunction, syncHandleChange);
    };

    const handleContentIdentifierChangeNew = (row, isAddAction, index, i) => {
        let value = [];
        if ('contentIdentifiers' in selectedFunction) {
            value = [...selectedFunction.contentIdentifiers];
        }
        if (isAddAction) {
            value.push(row);
        } else {
            value.splice(i, 1);
        }

        const data = {
            target: {
                value: value,
                name: "contentIdentifiers",
            }
        };
        handleChange(data);
    };

    const handleMethodChange = (row, isAddAction, index, i) => {
        let value = [];
        if ('methods' in selectedFunction) {
            value = [...selectedFunction.methods];
        }
        if (isAddAction) {
            value.push(row);
        } else {
            value.splice(i, 1);
        }

        const data = {
            target: {
                value: value,
                name: "methods",
            },
        };
        handleChange(data);
    };


    const getMethods = () => {
        const response = [];
        for (const i in methods) {
            const method = methods[i];
            if (method.displayOrder !== -1) {
                response.push({id: method.id, name: t('report.current_language') === "FINNISH" ? method.nameFi : method.nameSv, descriptionFi: method.descriptionFi, descriptionSv: method.descriptionSv})
            }
        }
        response.sort((a,b) => a.name.localeCompare(b.name));
        return response;
    }


    const selectOrganizer = (row, isAddAction, index, i) => {
        let value = [];
        if ('organizers' in selectedFunction) {
            value = [...selectedFunction.organizers];
        }
        if (isAddAction) {
            value.push(row);
        } else {
            value.splice(i, 1);
        }

        const data = {
            target: {
                value: value,
                name: "organizers",
            },
        };
        handleChange(data);
    }

    const sharedMunicipalityItems = selectedFunction.sharedMunicipalities ? selectedFunction.sharedMunicipalities : [];

    const sharedMunicipalities = () => {
        if (sharedMunicipalityItems.length === 0) {
            return <></>
        }
        else {
            return <p>{t('function.shared_municipalities')+" "+sharedMunicipalityItems.join(", ")}</p>;
        }
    }

    const shareFunctionChoice = [
        {
            label: t('function.use_share'),
            key: "shared",
            value: selectedFunction.shared
        }
    ]

    const selectedOrganizersRows = [];
    const permanentOrganizers = [];
    const functionOrganizers = []

    if ('organizers' in selectedFunction) {
        selectedFunction.organizers.forEach(function (organizer) {
            functionOrganizers.push(organizer)
            selectedOrganizersRows.push(organizer.id);
        });
    } else if (editorActivated) {
        selectedMunicipalityUsers.forEach((user) => {
            if (user.id === authenticatedUser.id)
                selectedFunction.organizers = [user];
        });
        selectedOrganizersRows.push(authenticatedUser.id);
    }
    if (forceOrganizer && !permissionToCreateFunctionBehalfOfAnother && (selectedFunction.id === null || selectedFunction.id === undefined)) {
        permanentOrganizers.push(authenticatedUser.id);
    }

    const combinedOrganizersAndUsers = [...selectedMunicipalityUsers];
    functionOrganizers.forEach(organizer => {
        if (!combinedOrganizersAndUsers.find(user => user.id === organizer.id)) {
            combinedOrganizersAndUsers.push(organizer);
        }
    });

    const handleStartDateChange = (e) => {
        const syncHandleChange = (event, changedData) => {
            let newData = changedData ? { ...changedData } : { [event.target.name]: event.target.value };
            const isCopying = action === 'copy';
            const isUsingTemplate = selectedFunction && selectedFunction.templateName != null;

            if (isCopying || isUsingTemplate) {
                if (newData.startDate) {
                    newData.endDate = newData.startDate;
                }
                if (newData.startDatetime) {
                    newData.endDatetime = newData.startDatetime;
                }
            }
            handleChange(event, newData);
        };
        handleDateTimeChange(e, 'startDate', selectedFunction, syncHandleChange);
    };

    return (
        <>
            <Grid className={'MuiGrid-item function-info-comp'} size={12} error={sectionHasError([
                            'name',
                            'eventType',
                            'contentIdentifiers',
                            'methods',
                            'startDate',
                            'startTime',
                            'startDatetime',
                            'endDate',
                            'eventHours',
                            'organizers',
                            'service',
                            'shared'
                        ]) ? t('errors.has error') : null}>
                <CompPartitionHeader text={t("function.function_information")}/>
                    <Typography className={'modalDescription'} tabIndex={0}>
                        {t("function.function_information_description")}
                    </Typography>
                <Grid container spacing={0} sx={{paddingLeft: "0px !important", marginTop: "5%"}}>
                    <Grid  size={{xs: 12,  sm: 6}}>
                        <CompTextFieldNew
                            label={`${t('function.function_name')}*`}
                            value={selectedFunction.name}
                            disabled={disableAll}
                            name="name"
                            isLabelShrink={true}
                            error={fieldErrors.name}
                            onChange={handleChange}
                        />
                        <CompDropdownNew
                            label={`${t('function.service')}*`}
                            className={'function-dropdown'}
                            selectedValue={selectedFunction.serviceId}
                            rows={getServiceOptions(t, services)}
                            disabled={disableAll}
                            name="serviceId"
                            error={fieldErrors.service}
                            onChange={handleChange}
                        />
                        <CompDropdownNew
                            label={`${t('function.function_type')}*`}
                            className={'function-dropdown'}
                            selectedValue={selectedFunction.eventType}
                            rows={getFunctionTypeOptions()}
                            disabled={disableAll}
                            name="eventType"
                            error={fieldErrors.eventType}
                            onChange={handleChange}
                        />
                        <SearchMultiselectDropdown
                            label={`${t('function.content_identifiers')}*`}
                            selectedRows={selectedContentIdentifiers}
                            rows={intendedContentIdentifierList}
                            className={"content_identifiers-dropdown"}
                            keyColumn={'id'}
                            valueColumn={'currentTitle'}
                            disabled={disableAll}
                            name="contentIdentifiers"
                            error={fieldErrors.contentIdentifiers}
                            onSelect={handleContentIdentifierChangeNew}
                        />
                        <SearchMultiselectDropdown
                            label={t('common.methods')}
                            selectedRows={selectedMethods}
                            rows={getMethods()}
                            className={"methods-dropdown"}
                            keyColumn={'id'}
                            valueFunc={(row) => row.name}
                            disabled={disableAll}
                            name="methods"
                            error={fieldErrors.methods}
                            onSelect={handleMethodChange}
                        />
                        <CompTextFieldNew
                            isLabelShrink={true}
                            label={t('function.description')}
                            value={selectedFunction.description}
                            disabled={!editorActivated && !shared}
                            name="description"
                            multiline
                            rows={6}
                            error={fieldErrors.description}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid className="date_comp-wrapper" size={{xs: 12, sm: 6}}>
                        <Grid container spacing={0} sx={{paddingRight: "0px !important"}}>
                            <Grid size={{xs: 12, sm: 6}}>
                                <CompDatePickerNew
                                    label={`${t('function.start_date')}*`}
                                    value={formatISODateStr(selectedFunction.startDatetime ?? selectedFunction.startDate)}
                                    isLabelShrink={true}
                                    className="picker_separator-start"
                                    disabled={disableAll || action === 'template'}
                                    name="startDate"
                                    error={fieldErrors.startDatetime}
                                    onChange={
                                        (action === 'copy' || (selectedFunction && selectedFunction.templateName != null))
                                            ? handleStartDateChangeForCopy 
                                            : e => handleDateTimeChange(e, 'startDate', selectedFunction, handleChange)
                                    }
                                />
                            </Grid>
                            <Grid size={{xs: 12, sm: 6}}>
                                <CompDatePickerNew
                                    label={`${t('function.end_date')}*`}
                                    value={formatISODateStr(selectedFunction.endDatetime ?? selectedFunction.endDate)}
                                    isLabelShrink={true}
                                    className="picker_separator-end"
                                    disabled={disableAll || action === 'template'}
                                    name="endDate"
                                    error={
                                        selectedFunction.startDatetime &&
                                        selectedFunction.endDatetime &&
                                        new Date(selectedFunction.endDatetime).setHours(0,0,0,0) <
                                        new Date(selectedFunction.startDatetime).setHours(0,0,0,0)
                                        ? t('end_date_error')
                                        : ''
                                    }
                                    onChange={e => handleDateTimeChange(e, 'endDate', selectedFunction, handleChange)}
                                    />
                                {action === 'template' && (
                                    <Tooltip sx={{ position: 'absolute' }} title="Et voi muokata päivämääriä toimintapohjassa" enterTouchDelay={0}>
                                        <IconButton size="medium">
                                            <QuestionMarkIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container spacing={0} sx={{paddingRight: "0px !important"}}>
                            <Grid size={{xs: 12, sm: 6}}>
                                <CompTimePickerNew
                                    label={`${t('function.start_time')}*`}
                                    value={selectedFunction.startDatetime ?? selectedFunction.startDate}
                                    isLabelShrink={true}
                                    className="picker_separator-start"
                                    disabled={disableAll}
                                    name="startTime"
                                    error={fieldErrors.startDatetime}
                                    onChange={e => handleDateTimeChange(e, 'startTime', selectedFunction, handleChange)}
                                />
                            </Grid>
                            <Grid size={{xs: 12, sm: 6}}>
                                <CompTimePickerNew
                                    label={`${t('function.end_time')}*`}
                                    value={selectedFunction.endDatetime ?? selectedFunction.endDate}
                                    isLabelShrink={true}
                                    className="picker_separator-end"
                                    disabled={disableAll}
                                    name="endTime"
                                    error={
                                        selectedFunction.startDatetime &&
                                        selectedFunction.endDatetime &&
                                        new Date(selectedFunction.startDatetime).setHours(0,0,0,0) ===
                                        new Date(selectedFunction.endDatetime).setHours(0,0,0,0) &&
                                        new Date(selectedFunction.endDatetime).getTime() <
                                        new Date(selectedFunction.startDatetime).getTime()
                                        ? t('end_time_error')
                                        : ''
                                    }
                                    onChange={e => handleDateTimeChange(e, 'endTime', selectedFunction, handleChange)}
                                />
                            </Grid>
                        </Grid>
                        <Grid className="event_hours-comp" sx={{paddingLeft: "11px"}}>
                            <EventHoursTimePicker
                                label={t('function.event_hours')}
                                value={selectedFunction.eventHours}
                                isLabelShrink={true}
                                disabled={disableAll}
                                name="eventHours"
                                error={fieldErrors.eventHours}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid className="function_organizers-comp" sx={{paddingLeft: "11px"}}>
                            <CompSearchInputNew
                                label={`${t('function.organizers')}*`}
                                multiselect
                                isLabelShrink={true}
                                rows={action === 'view' ? functionOrganizers : combinedOrganizersAndUsers}
                                keyColumn={'id'}
                                valueColumn={municipalitySelect ? ['firstName', 'lastName', [municipalities, 'mainMunicipalityId']]: ['firstName', 'lastName']}
                                disabled={!editorActivated && !shared}
                                hasPermissionToEdit={true}
                                selectedRows={selectedOrganizersRows}
                                permanentSelections={permanentOrganizers}
                                name="organizers"
                                error={fieldErrors.organizers}
                                onSelect={selectOrganizer}
                            />
                            <CompCheckbox
                                booleanmode={true}
                                rows={shareFunctionChoice}
                                selected={selectedFunction}
                                disabled={disableAll || action === "share"}
                                onChange={handleSelectChange}
                                name="shared"
                                className="shared"
                            />
                        </Grid>
                        {sharedMunicipalityItems.length > 0 && sharedMunicipalities()}
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        func: state.func,
        templates: state.func.templates,
        authenticatedUser: state.auth.authenticatedUser,
        selectedFunction: state.func.selectedFunction,
        organizationTree: state.municipality.organizationTree,
        selectedMunicipalityUsers: state.municipality.selectedMunicipalityUsers,
        functionFieldErrors: state.func.functionFieldErrors,
        services: state.root.services,
        contentIdentifiers: state.root.contentIdentifiers,
        methods: state.root.methods,
        municipalities: state.municipality.municipalities,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setFunction: (data) => dispatch(setFunction(data)),
        getSharedMunicipalities: (shareId) => dispatch(getSharedMunicipalities(shareId))
    };
}

export const FunctionInformationComp = connect(mapStateToProps, mapDispatchToProps)(FunctionInformationComponent);
